module.exports = __webpack_public_path__ + "static/media/Cracks.66a45fe7.gif";